import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { EventEmitterService } from './event-emitter.service';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SplashService {

  loginURL: string = null;
  loginTestimonial: string = null;
  registerURL: string = null;
  registerTestimonial: string = null;
  selftourTestimonial: string = null;
  openhouseTestimonial: string = null;
  agenttourTestimonial: string = null;
  applyTestimonial: string = null;

  constructor(private http: HttpClient, private eventEmitterService: EventEmitterService) {   
   }

  setupSplash(res: any, page: string)
  {   
    for (let index = 0; index < res.length; index++)
    {
      const element = res[index];

      if (element.query && element.query === "/login")
        {
          if (element.images && element.images.square)
          {
            this.loginURL = element.images.square;     
          }
          if (element.testimonial)
          {
            this.loginTestimonial = element.testimonial;
          }
        }
        else if (element.query && element.query === "/register")
        {
          if (element.images && element.images.square)
          {
            this.registerURL = element.images.square;
          }
          if (element.testimonial)
          {
            this.registerTestimonial = element.testimonial;
          }
        }
        else if (element.query && element.query === "/selftour")
        {
          if (element.testimonial)
          {
            this.selftourTestimonial = element.testimonial;
          }
        }
        else if (element.query && element.query === "/openhouse")
        {
          if (element.testimonial)
          {
            this.openhouseTestimonial = element.testimonial;
          }
        }
        else if (element.query && element.query === "/agenttour")
        {
          if (element.testimonial)
          {
            this.agenttourTestimonial = element.testimonial;
          }
        }
        else if (element.query && element.query === "/apply")
        {
          if (element.testimonial)
          {
            this.applyTestimonial = element.testimonial;
          }
        }
    }

    if (page === "login" && (this.loginURL || this.loginTestimonial))
    {
      this.updateSplash(page);
    }
    else if(page === "register" && (this.registerURL || this.registerTestimonial))
    {
      this.updateSplash(page);
    }
    else if(page === "selftour" && (this.selftourTestimonial))
    {
      this.updateSplash(page);
    }
    else if(page === "openhouse" && (this.openhouseTestimonial))
    {
      this.updateSplash(page);
    }
    else if(page === "agenttour" && (this.agenttourTestimonial))
    {
      this.updateSplash(page);
    }
    else if(page === "apply" && (this.applyTestimonial))
    {
      this.updateSplash(page);
    }
    
  }

  updateSplash(page: string)
  {     
    if (!this.loginTestimonial && !this.loginURL && !this.registerTestimonial && !this.registerURL)
    {
      this.http.get(environment.marketingAssetURL).subscribe(res => this.setupSplash(res, page));
    }
    else {
      if (page === "login")
      {
        this.checkImageSource(this.loginURL, this.updateImage(this.loginURL));
        this.eventEmitterService.splashChange(this.loginTestimonial);
      }
      if (page === "register")
      {
        this.checkImageSource(this.registerURL, this.updateImage(this.registerURL));
        this.eventEmitterService.splashChange(this.registerTestimonial);
      }
      if (page === "selftour")
      {
        this.eventEmitterService.splashChange(this.selftourTestimonial);
      }
      if (page === "openhouse")
      {
        this.eventEmitterService.splashChange(this.openhouseTestimonial);
      }
      if (page === "agenttour")
      {
        this.eventEmitterService.splashChange(this.agenttourTestimonial);
      }
      if (page === "apply")
      {
        this.eventEmitterService.splashChange(this.applyTestimonial);
      }
    }
  }

  
  checkImageSource(imageSrc: string, good: any) {
    var img = new Image();
    img.onload = good; 
    img.onerror = function() {
      document.getElementById('splash-image').style.backgroundImage= "url('/assets/images/FallbackImage_House.jpg')";
    };
    img.src = imageSrc;
  }

  updateImage(url: string)
  {
    document.getElementById('splash-image').style.backgroundImage= `url(${url})`;
  }

}
